let ToolKinds = /*#__PURE__*/function (ToolKinds) {
  ToolKinds[ToolKinds["TOOLBOX"] = 0] = "TOOLBOX";
  ToolKinds[ToolKinds["COURSE_PICKER"] = 1] = "COURSE_PICKER";
  ToolKinds[ToolKinds["SEARCH"] = 2] = "SEARCH";
  ToolKinds[ToolKinds["USER_AREA"] = 3] = "USER_AREA";
  ToolKinds[ToolKinds["LOG_IN"] = 4] = "LOG_IN";
  return ToolKinds;
}({});

export { ToolKinds };
//# sourceMappingURL=typing.tool-kinds.js.map
